export default "__VITE_ASSET__b6e3f973__"